<template>
  <h2 class="title-info">
    <div class="is-size-5-touch octobus__columns is-vcentered is-mobile" @click="setShowTicket">
      <div class="octobus__column">
        <span class="departure is-block-touch is-size-4-desktop">{{departure}}</span>
        <span class="is-hidden-touch is-size-4-desktop">-</span>
        <span class="arrived is-block-touch is-size-4-desktop">{{arrived}}</span>
        <span class="date is-size-7-touch">{{depDate}}</span>
        <span class="passcount is-size-7-touch">{{passangers(passcount)}}</span>
      </div>
      <div class="octobus__column is-narrow-touch">
        <p class="showmore has-text-right-desktop">
          <span>
            <font-awesome-icon
              :icon="doubleIcon"
            >
            </font-awesome-icon>
          </span>
        </p>
      </div>
    </div>
  </h2>
</template>

<script>
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import { faAngleDoubleDown, faAngleDoubleUp } from '@fortawesome/fontawesome-free-solid';

export default {
  name: 'TitleInfo',
  components: {
    FontAwesomeIcon,
  },
  props: {
    departure: {
      type: String,
      default() {
        return '';
      },
    },
    arrived: {
      type: String,
      default() {
        return '';
      },
    },
    depDate: {
      type: String,
    },
    passcount: {
      type: [String, Number],
      required: true,
    },
    showTicket: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    setShowTicket() {
      this.$emit('showTicket', !this.showTicket);
    },
    passangers(value) {
      let str = Number(value);

      if (value === 0 || value > 4) {
        str += ` ${this.$tc('tripInfo.passenger', 0)}`;
      } else if (value === 1) {
        str += ` ${this.$tc('tripInfo.passenger', 1)}`;
      } else {
        str += ` ${this.$tc('tripInfo.passenger', 2)}`;
      }

      return str;
    },
  },
  computed: {
    doubleIcon() {
      return this.showTicket ? faAngleDoubleUp : faAngleDoubleDown;
    },
  },
  created() {

  },
};
</script>

<style lang="scss" scoped>
#app, #auth {
  .title-info {
    cursor: pointer;

    .showmore {
      color: #8a8a8a;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TripInfo/TitleInfo.vue